module.exports = __webpack_public_path__ + "static/media/bathy.d409a86a.PNG";